import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest, fetchJson } from "@/lib/queryClient";
import type {
  NovaOrganizacao,
  OrganizacaoDTO,
  PatchOrganizacao,
} from "@shared/plataforma-organizacoes";

/**
 * Plataforma › Organizações (§B).
 *
 * ⚠️ NENHUM HOOK CRIA USUÁRIO. Não existe `useCriarAcesso`, não há senha, não há
 * convite. O acesso nasce do claim, pelo link que prova posse — se algum dia
 * aparecer um hook de credencial aqui, é sinal de que a regra foi contornada.
 */
const ORGS = "/api/plataforma/organizacoes";

export function useOrganizacoes(ativo: boolean) {
  return useQuery<OrganizacaoDTO[]>({
    queryKey: [ORGS],
    queryFn: () => fetchJson<OrganizacaoDTO[]>(ORGS),
    enabled: ativo,
  });
}

export function useCriarOrganizacao() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dados: NovaOrganizacao) =>
      apiRequest("POST", ORGS, dados).then(r => r.json()) as Promise<OrganizacaoDTO>,
    onSuccess: () => qc.invalidateQueries({ queryKey: [ORGS] }),
  });
}

export function useAtualizarOrganizacao() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dados: { id: string } & PatchOrganizacao) => {
      const { id, ...campos } = dados;
      return apiRequest("PATCH", `${ORGS}/${id}`, campos).then(r => r.json()) as Promise<OrganizacaoDTO>;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [ORGS] }),
  });
}
